import { TimelineMax } from "gsap";
import { IDimConfig, ResizeHelper } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { SplashView } from "../SplashController"
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../../SanGameConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TextStyleConfig } from "../../../../translation/TextStyleConfig";
import { RevealerManager } from "../../revealer/RevealerManager";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

import { BLEND_MODES } from "pixi.js";
import { SoundManager } from "../../../../resource/sound/SoundManager";
import { SoundConfig } from "../../../../SoundConfig";


export class SplashViewJWWon extends BaseView implements SplashView  {
    
    private static _txt_collect:PIXI.Text;
    private static _txt_collect_Flash:PIXI.Text;

    private static layoutDim: IDimConfig = {
        dimOrientation: {
            landscape: {
                scale: new PIXI.Point(0.6, 0.6),
                position: new PIXI.Point(360, 310),
                layout: {
                    left: new PIXI.Point(360, 310),
                    right: new PIXI.Point(360, 310)
                }
            },
            portrait: {
                scale: new PIXI.Point(0.65, 0.65),
                position: new PIXI.Point(360, 300)
            }
        },
        WIDTH: 240,
        HEIGHT: 64,
    };

    protected _timeLine:TimelineMax;

    protected DEFAULT_TXT_STYLE:TextStyleOptions;

    private static valueX:number = 0;

    constructor(textStyle:TextStyleOptions){
        super();
        this.DEFAULT_TXT_STYLE = textStyle;
        this.visible = false;
    }

    protected initAnimations():void{

        SplashViewJWWon._txt_collect = this.createText("X0");
        SplashViewJWWon._txt_collect.style = TextStyleConfig.COLLECT_TEXT;

        SplashViewJWWon._txt_collect_Flash = this.createText("X0");
        SplashViewJWWon._txt_collect_Flash.style = TextStyleConfig.COLLECT_TEXT;
        SplashViewJWWon._txt_collect_Flash.blendMode = BLEND_MODES.ADD;
        SplashViewJWWon._txt_collect_Flash.alpha = 0;

        StageManager.getLayer(SanGameConfig.instance.LAYERS.POSTER.name).addChild(this);
    }

    private createText(val: string): PIXI.Text {
        const temp: PIXI.Text = new PIXI.Text(Translation.translate(val));
        temp.style = this.DEFAULT_TXT_STYLE;
        temp.anchor.set(0.5, 0.5);
        this.addChild(temp);
        return temp;
    }
   
    public play():TimelineMax{
        this.visible = true;
        SplashViewJWWon.changeValue(0);
        SplashViewJWWon._txt_collect.position.y =  Helper.copyLocalPosition(SplashViewJWWon._txt_collect, RevealerManager.getTopBar(2)).y - (SplashViewJWWon._txt_collect.height/2)/SplashViewJWWon._txt_collect.scale.y;
        
        this._timeLine = new TimelineMax();
        this._timeLine.fromTo(this,0.6,{alpha:0},{alpha:1},0);
        this._timeLine.fromTo(SplashViewJWWon._txt_collect.position,0.25,{x:320},{x:360},0);
        this._timeLine.fromTo(SplashViewJWWon._txt_collect_Flash.position,0.25,{x:320},{x:360},0);
        return this._timeLine;
    }

    public stop():TimelineMax{
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax({onComplete:() => this.visible = false}));
        this._timeLine.add(() => SoundManager.playSoundEffect(SoundConfig.instance.FS_MULTIPLIER_MOVE_DOWN), 0);
        this._timeLine.to(SplashViewJWWon._txt_collect.position,0.4,{y:360}, 0);
        this._timeLine.to(this,0.35,{alpha:0});
        
        return this._timeLine;
    }

    private static updateTL:TimelineMax;

    public static changeValue(amm:number):void{
        
        this.valueX = amm;
        this.updateTL = Helper.timeLineKiller(this.updateTL!,new TimelineMax({onComplete:() => SplashViewJWWon._txt_collect.text = "X"+amm}),true);
        const sizeTo:number = ResizeHelper.calcDim(SplashViewJWWon.layoutDim).scale.x + (amm*0.095);
        const sizeGrow:number = sizeTo*1.27;
        this.updateTL.to(SplashViewJWWon._txt_collect.scale,0.1,{x:sizeGrow,y:sizeGrow},0);
        this.updateTL.to(SplashViewJWWon._txt_collect_Flash.scale,0.1,{x:sizeGrow,y:sizeGrow},0);
        this.updateTL.fromTo(SplashViewJWWon._txt_collect_Flash,0.1,{alpha:0},{alpha:1},0);

        this.updateTL.add(() => {
            SplashViewJWWon._txt_collect.text = "X"+amm;
            SplashViewJWWon._txt_collect_Flash.text = "X"+amm;
        },0.1);

        this.updateTL.to(SplashViewJWWon._txt_collect_Flash,0.15,{alpha:0},0.1);

        this.updateTL.to(SplashViewJWWon._txt_collect_Flash.scale,0.15,{x:sizeGrow*1.35,y:sizeGrow*1.35},0.1);
        this.updateTL.to(SplashViewJWWon._txt_collect.scale,0.15,{x:sizeTo,y:sizeTo},0.1);
    }

    public onResize():void{

        if(this._timeLine && this._timeLine.isActive()) this._timeLine.progress(1);

        SplashViewJWWon._txt_collect.scale = MathHelper.pointAdd(ResizeHelper.calcDim(SplashViewJWWon.layoutDim).scale,(SplashViewJWWon.valueX*0.095));
        SplashViewJWWon._txt_collect.position.y =  Helper.copyLocalPosition(SplashViewJWWon._txt_collect, RevealerManager.getTopBar(2)).y - (SplashViewJWWon._txt_collect.height/2)/SplashViewJWWon._txt_collect.scale.y;

        SplashViewJWWon._txt_collect_Flash.scale = SplashViewJWWon._txt_collect.scale;
        SplashViewJWWon._txt_collect_Flash.position = SplashViewJWWon._txt_collect.position;
    }
}
